import { AppRoutingConstants } from "../../app-routing.constants";
export class UrlConstants {
    static API_V2 = "api/v2/";
    static GET_MY_PORTAL_INFORMATION_URL = AppRoutingConstants.createEndpointRoutev2("User", "GetMyPortalInformation");
    static SIGNAL_R_HUB_SUFFIX = "notifyHub";
    static GEO_PROCESSING = "Geoprocessing";
    static GET_TRUE_CENTROID = "GetTrueCentroid";
    static EXECUTE = "execute";
    static GP_SERVER = "GPServer";
}
